import React, { useEffect, useState } from "react";
import ContactUs from "../../sections/home/Contactus";
import '../../Assets/CSS/profile.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import profileimg from '../../Assets/Images/profile/profile.jpeg'; 
import Membership from "./Membership";
import Enquiries from "./Enquiries";
import ProfileInfo from "./ProfileInfo";
import EditProfile from "./EditProfile";
import DetailEnquiry from "./DetailEnquiry";
import axios from "axios";
import Cookies from 'js-cookie';



const Profile = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [profileInfo, setProfileInfo] = useState({
  });
  const navigate = useNavigate()
   const [showLogoutModal, setShowLogoutModal] = useState(false);
  

// Call the function

  const cookieOptions = {
    //secure: process.env.NODE_ENV === 'production', // Secure in production
   // sameSite: 'strict',
    sameSite: 'Lax',   // ✅ best choice for HTTP
    path: '/',
    expires: 1 // 1 day expiration
  };

 
const handleLogout = () => {
 
    // Remove cookies
  // document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; SameSite=Strict; Path=/`;
  // document.cookie = `roles=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict;`;

    Cookies.remove('token', cookieOptions);
    Cookies.remove('roles', cookieOptions);
    Cookies.remove('user', cookieOptions);
  setIsLoggedIn(false);
  console.log("logout successfully===profile")
  window.location.reload();

      const BASE_URL =process.env.REACT_APP_ADMIN_lOGOUT_URL
       const BASE_URL_BUYER =process.env.REACT_APP_BUYER_URL
        const loginOrigin = Cookies.get("loginOrigin");
         Cookies.remove("loginOrigin");

    // Redirect
  if (loginOrigin === "admin") {
    window.location.href = BASE_URL; //ADMIN
  } else {
    window.location.href = BASE_URL_BUYER; // BUYER
  }
};



  return (
    <div className="common-margin ">
       <div className="container-fluid pb-5" style={{ background: '#F5F5F5', minHeight: '100vh' }}>
  <div className="row gap-2 mt-5 px-5" style={{ minHeight: '100vh'}}>
    {/* Sidebar - Fixed */}
    <div className="col-md-3 col-lg-3 col-12 d-flex flex-column">
      {/* Profile Section */}
      <div className="profile-section mt-5 w-100 mb-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <img
              src={profileInfo.profileImageUrl}
              alt="Profile"
              className="rounded-circle"
              style={{ width: "42px", height: "42px", cursor: "pointer" }}
              onClick={() => setActiveTab("profile")}
            />
            <h5 className="mt-1 mb-0">{profileInfo.firstName} {profileInfo.lastName}</h5>
          </div>
          <Icon icon="weui:arrow-outlined" className="fs-5 mt-1" />
        </div>
      </div>
      {/* Navigation Section */}
      <div className="navigation-section w-100  d-flex flex-column" style={{ minHeight: '100vh'}}>
        {["profile", "enquiries", "membership"].map((tab) => (
          <button
            key={tab}
            className={`btn ${activeTab === tab ? "btn-select" : "btn-unselect"} w-100 mb-2 text-start`}
            onClick={() => setActiveTab(tab)}
          >
            <Icon icon={tab === "profile" ? 'pajamas:profile' : tab === "enquiries" ? 'tdesign:task' : 'material-symbols-light:card-membership-outline'} className="fs-6 mx-2" />
            <Icon icon='weui:arrow-outlined' className="fs-5 mt-1 float-end" />
            {tab === "profile" ? "My Profile" : tab === "enquiries" ? "My Enquiries" : "Membership"}
          </button>
        ))}
          <button className="text-danger text-start logout-button border-0 bg-white w-100 
          mt-auto" style={{ marginBottom: "20px" }}
          //  onClick={handleLogout}
              onClick={() => setShowLogoutModal(true)}
           >
    <span className="logout-icon">
      <Icon icon='material-symbols:logout' className="fs-3 p-1" />
    </span>
    Log Out
  </button>
      </div>
    </div>

    {/* Right Side - Dynamic Content */}
   
     <div className="col-md-8 col-lg-8 col-12 bg-white main-section d-flex flex-column mt-5">
    {activeTab === "profile" ? (
      <ProfileInfo setActiveTab={setActiveTab} profileInfo={profileInfo || {} } setProfileData={setProfileInfo} />
    ) : activeTab === "editProfile" ? (
      profileInfo ? (
        <EditProfile setActiveTab={setActiveTab} profileInfo={profileInfo} setProfileInfo={setProfileInfo} />
      ) : (
        <p>Loading...</p>
      )
    ) : activeTab === "enquiries" ? (
      <Enquiries setActiveTab={setActiveTab} setSelectedEnquiry={setSelectedEnquiry} />
    ) : activeTab === "viewDetail" ? (
      <DetailEnquiry setActiveTab={setActiveTab} enquiry={selectedEnquiry} />
    ) : (
      <Membership />
    )}
  </div>

  </div>
      </div> 

      <ContactUs />
         {showLogoutModal && (
                      <div
                          className="modal show d-block d-flex justify-content-center align-items-center"
                          style={{
                              boxShadow: '0px 4px 6px 0px #00000026',
                              background: '#000000B2',
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100vw',
                              height: '100vh',
                              zIndex: 1050
                          }}
                      >
                          <div className="modal-dialog" style={{ width: '500px', height: '300px', maxWidth: '90%' }}>
                              <div className="modal-content pt-4">
                                  <div className="d-flex justify-content-end px-3">
                                      <Icon
                                          icon='material-symbols-light:close'
                                          className='close-btn fs-5'
                                          onClick={() => setShowLogoutModal(false)}
                                          style={{ cursor: 'pointer' }}
                                      />
                                  </div>
                                  <h5 className="pt-4 fw-bold fs-5 px-5" style={{ textAlign: 'center' }}>Logout Confirmation</h5>
                                  <p className='px-5 fw-normal fs-6' style={{ color: '#606060', textAlign: 'center' }}>
                                      Are you sure you want to logout?
                                  </p>
                                  <div className="d-flex justify-content-center align-items-center gap-4 mt-4 mb-4">
                                      <button
                                          className="rounded-5 border cancelbtn px-5 py-1"
                                          onClick={() => setShowLogoutModal(false)}
                                      >
                                          Cancel
                                      </button>
                                      <button
                                          className="px-5 rounded-5 border py-1"
                                          style={{
                                              background: '#371300',
                                              color: '#FFFFFF'
                                          }}
                                          onClick={handleLogout}
                                      >
                                          Yes, Logout
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  )}
    </div>

  );
};


export default Profile;





